import { getSharedConfig } from "../../createSharedConfig"
import { getBuyRequestMeta, getSimpleForBuyRequest } from "@/js/helpers/buy-request"
import { RACK_COLORS } from "@/js/pages/product/rackbuilder/constants"
import { RackOptions } from "@/js/pages/product/rackbuilder/RackTypes"
import { findBundleProduct, getAccessoryQuantity } from "@/js/pages/product/rackbuilder/utils/product-lookup"
import { getCommonAccessorySelections, getFrontSelection, getDepthSelection } from "@/js/pages/product/rackbuilder/utils/selection-utils"
import { IRogue, BuyRequest } from "@/js/services/RogueTypes"

export function createTwinAddonConfig(rogue: IRogue, buyRequest: BuyRequest): RackOptions {
  const meta = getBuyRequestMeta(buyRequest, rogue)
  const rack = findBundleProduct(rogue, buyRequest, 'rack') || getSimpleForBuyRequest(buyRequest, rogue)

  const sharedConfig = getSharedConfig(rogue, buyRequest)
  const { trolleySelection, lowRowSelection, latBarSelection } = getCommonAccessorySelections(rogue, buyRequest, sharedConfig.materials || {})

  // Twin 6-post: nameplate at 90/100", crossmember at 80"
  const back = sharedConfig.height === '80' ? 'crossmember top 4' : 'nameplate'

  return {
    ...sharedConfig,
    back            : back,
    front           : getFrontSelection(rogue, buyRequest, meta) || 'skinny',
    edition         : 'twin',
    color           : RACK_COLORS['Rogue Red'],
    jcup            : '',
    depth           : getDepthSelection(rack, meta),
    sixPost         : true,
    storagePosts    : false,
    ghostRack       : false,
    ftShrouds       : rack?.attributes.rig_or_wm !== 'No',
    spotterArms     : getAccessoryQuantity(rogue, buyRequest, 'safety spotter'),
    frontStabilizer : Boolean(findBundleProduct(rogue, buyRequest, 'half rack feet', true)),
    trolleySelection,
    latBarSelection,
    lowRowSelection,
    isAddon         : true,
  }
}
